import { render, staticRenderFns } from "./ApprovalsReport.vue?vue&type=template&id=42a38265&scoped=true"
import script from "./ApprovalsReport.vue?vue&type=script&lang=js"
export * from "./ApprovalsReport.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsReport.vue?vue&type=style&index=0&id=42a38265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a38265",
  null
  
)

export default component.exports